var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"podcasts-section"},[_c(("podcast-section-" + _vm.section),{ref:"section",tag:"component",attrs:{"id":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }